import styled from 'styled-components';

export const StyledBylaws = styled.div`
    padding: 100px 10px;
    
    span {
        font-weight: bold;
        display: block;
        padding-bottom: 3px;
    }

    section {
        padding-left: 10px;
    }

    h3 {
        padding-top: 8px;
    }
`